export const environment = {
  production: true,
  current_environment_name: 'Testing',
  server: 'koyeb',
  is_whitelist_enabled: true,
  is_HTTPS_mandatory: true,
  ui: 'ec29dd332adf4037ab332ab61ee7df06',
  usr_pwd: 'd763odnd03lmsal',
  service_type: 'express',
  url: {
    service: 'https://test-bill-srvc.pnixsoft.com/',
    bulk_service: 'https://test-bill-srvc-bulk.pnixsoft.com/',
    bkp_service: 'https://test-bill-srvc-bulk.pnixsoft.com/',
    image: 'https://storage.googleapis.com/dev.img.lazybill.com/gal/',
    app: 'https://test-bill.pnixsoft.com/',
    app_without_www: 'https://test-bill-srvc.pnixsoft.com/',
    offlline_service: 'http://localhost:3012/',
    lbs_services: ['https://test-bill-srvc.pnixsoft.com/'],
  },
};
